import React from "react";
import { BackIcon, defaultLogo } from "../assets/Icons";

const UserStripCard = ({
  details = {},
  type = "Group",
  loading = false,
  handleBack = () => {},
  hideBackBtn = false,
}) => {
  const getInitials = (name = "") => {
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0][0]?.toUpperCase() || "";
    return `${words[0][0]?.toUpperCase() || ""}${words[1][0]?.toUpperCase() || ""}`;
  };

  return (
    <>
      <div className="dashbord-header">
        {!hideBackBtn && (
          <div className="circlebtn" onClick={handleBack}>
            <span className="circlebtncont">
              <BackIcon />
            </span>
          </div>
        )}
        {loading ? (
          <div className="loading-spinner">
            <div className="skeleton skeleton-avatar" style={{ width: "3rem", height: "3rem" }} />
          </div>
        ) : (
          <div className="img-avatar">
            <div className={`groupUserStrip ${type == "User" ? "userimage" : ""}`}>
              {details?.avatar || details?.Image ? (
                <img src={details?.avatar || details?.Image || defaultLogo} alt="user image" />
              ) : (
                <span className="initials">{getInitials(details?.name || details?.Name)}</span>
              )}
            </div>
          </div>
        )}

        <div className="teamdashdata">
          <div className="user-name">
            {loading ? (
              <div className="skeleton skeleton-text" style={{ width: "3rem", height: "1rem" }} />
            ) : (
              details?.name || details?.Name
            )}
            {loading ? (
              <div className="skeleton skeleton-text" style={{ width: "3rem", height: ".8rem" }} />
            ) : (
              <p className="d-flex align-items-center">{type} </p>
            )}
          </div>
          {!!(type == "User") && (
            <div className="user-email">
              {loading ? (
                <div className="skeleton skeleton-text" style={{ width: "7rem", height: ".8rem" }} />
              ) : (
                details?.userMail
              )}{" "}
              {!!details?.user_id && `| ${details?.user_id}`}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UserStripCard;
